import styled from 'styled-components';

export const ConfirmationNumber = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-top: 13px;
`;

export const InputBox = styled.input`
  width: 70%;
  margin: 0 auto;
  height: 51px;
  font-size: ${({ theme }) => theme.FONT_SIZES.XLARGE};
  text-align: center;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  -moz-appearance: none;

  &:focus {
    border: 2px solid ${({ theme }) => theme.COLORS.TERTIARY};
    box-shadow: rgb(0 32 255 / 30%) 0px 1px 12px;
  }
`;

export const MissingCode = styled.div`
  margin-top: 24px;
  text-decoration: underline;
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  cursor: pointer;
`;
